import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getSelectedProductsWithData,
  getGiftsSubTotal,
  getGiftsTotal,
  getGiftsBasketQuantity,
  getGiftsGiftWrappingCost,
  getGiftsDeliveryCost,
} from "src/redux/gifts/selectors";
import CheckoutReview from "src/react/components/checkout-review";

function Review({
  children,
  products = [],
  basketQuantity,
  editBasketLink,
  total,
  orderValue,
  giftWrappingCost,
  deliveryCost,
}) {
  return (
    <CheckoutReview
      children={children}
      products={products}
      basketQuantity={basketQuantity}
      editBasketLink={editBasketLink}
      total={total}
      orderValue={orderValue}
      giftWrappingCost={giftWrappingCost}
      deliveryCost={deliveryCost}
    />
  );
}

Review.propTypes = {
  editBasketLink: PropTypes.string.isRequired,
  children: PropTypes.any,
  products: PropTypes.array,
  basketQuantity: PropTypes.number,
  discount: PropTypes.number,
  total: PropTypes.number,
  orderValue: PropTypes.number,
  giftWrappingCost: PropTypes.number,
  deliveryCost: PropTypes.number,
};

const mapStateToProps = (state) => ({
  products: getSelectedProductsWithData(state),
  basketQuantity: getGiftsBasketQuantity(state),
  orderValue: getGiftsSubTotal(state),
  total: getGiftsTotal(state),
  giftWrappingCost: getGiftsGiftWrappingCost(state),
  deliveryCost: getGiftsDeliveryCost(state),
});

export default connect(mapStateToProps)(Review);
